/**
 * Mirrors `UserEvents::Kinds` on the API. These strings are the contract
 * between a publisher there and a handler here.
 *
 * `satisfies` is doing real work: every value is checked against the generated
 * `UserEventKindEnum`, so renaming a kind on the API and regenerating the schema
 * breaks the build here — instead of leaving a handler that silently never
 * matches another event again.
 */
export const USER_EVENT_KINDS = {
  BULK_IMPORT_COMPLETED: 'BULK_IMPORT_COMPLETED',
} as const satisfies Record<string, UserEventKindEnum>;

/**
 * How often to sweep for unread events when websockets are off. This is the
 * whole delivery latency in that mode, and it is deliberately slow: these
 * events report background work that took minutes, so nobody is watching the
 * clock for them.
 */
export const UNREAD_POLL_INTERVAL = 30_000;
